<div class="rewards-v2">
  <div class="rewards-header">
    <div class="header-content">
      <div class="title-section">
        <h1 class="page-title">Rewards</h1>
        <p class="page-subtitle">Track your success and rewards.</p>
      </div>
      <div class="lifetime-rewards-card">
        <div class="rewards-amount">
          <div class="trophy-icon">
            <img src="/assets/images/rewards/trophy.png" alt="Trophy" class="trophy-image">
          </div>
          <span class="amount">{{ lifetimeRewards }}</span>
        </div>
        <span class="lifetime-label">Lifetime rewards</span>
      </div>
    </div>
  </div>

  <div class="offered-section">
    <div *ngIf="isLoadingOffered" class="cards-skeleton">
      <app-offered-reward-card-skeleton
        *ngFor="let _ of offeredCardSkeletons; trackBy: trackByIndex">
      </app-offered-reward-card-skeleton>
    </div>

    <div *ngIf="!isLoadingOffered && offeredRules.length === 0" class="empty-state-container">
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="No active rewards"
        description="There are no active reward rules configured for your shop."
        [showAction]="false">
      </app-empty-result>
    </div>

    <app-offered-rewards-carousel
      *ngIf="!isLoadingOffered && offeredRules.length > 0"
      [rules]="offeredRules">
    </app-offered-rewards-carousel>
  </div>

  <div class="rewards-history">
    <div class="history-header">
      <h2 class="history-title">Rewards History</h2>
      <div class="period-selector">
        <span class="period-label">Period</span>
        <div class="period-dropdown-wrapper">
          <button
            class="dropdown-button"
            (click)="toggleDateRangePicker(); $event.stopPropagation()">
            <span>{{ selectedPeriod }}</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                 [class.rotated]="isDateRangePickerOpen">
              <path d="M5.28 7.38L10 12.1L14.72 7.38" stroke="#15172E" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <app-date-range-picker
            [isOpen]="isDateRangePickerOpen"
            [selectedPeriod]="selectedPeriod"
            [customDateRange]="customDateRange"
            [periodOptions]="periodOptions"
            (periodChange)="onDateRangePeriodChange($event)"
            (customDateRangeChange)="onCustomDateRangeChange($event)"
            (close)="closeDateRangePicker()"
            (apply)="onDateRangeApply($event)">
          </app-date-range-picker>
        </div>
      </div>
    </div>

    <app-rewards-history-table-v2
      [columns]="historyColumns"
      [items]="historyItems"
      [loading]="isLoadingHistory">
    </app-rewards-history-table-v2>

    <app-pagination-bar
      *ngIf="!isLoadingHistory && historyItems.length > 0"
      [paginationData]="paginationData"
      [itemsPerPageOptions]="itemsPerPageOptions"
      (pageChange)="onPageChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)">
    </app-pagination-bar>
  </div>
</div>
